import React, { createContext, useContext, useReducer } from 'react'

const Cartstatecontext = createContext();
const Cartdispatchcontext = createContext();

const reducer = (state, action) => {
    switch (action.type) {
        case "ADD":
            return [...state, {
                name: action.name,
                img: action.img,
                price: action.price,
                qty: action.qty,
            }]
        case "REMOVE":
            const newArr = [...state]
            newArr.splice(action.index, 1)
            return newArr

        case "DECREASE_QUANTITY":
            return state.map((food, index) => {
                if (index === action.index) {
                    return {
                        ...food,
                        qty: food.qty - 1
                    }
                }
                return food;
            });
        case "INCREASE_QUANTITY":
            return state.map((food, index) => {
                if (index === action.index) {
                    return {
                        ...food,
                        qty: food.qty + 1
                    }
                }
                return food;
            });
        case "DROP":
            const emptyarry = []
            return emptyarry

        // case "SEARCH":
        //     return console.log(state.filter(data=>data.name.includes("O")));

        default:
            console.log("Error in Reducer");
    }
}

export const CardProvider = ({ children }) => { // Corrected parameter name
    const [state, dispatch] = useReducer(reducer, [])
    return (
        <Cartdispatchcontext.Provider value={dispatch}>
            <Cartstatecontext.Provider value={state}>
                {children}
            </Cartstatecontext.Provider>
        </Cartdispatchcontext.Provider>
    )
}

export const useCart = () => useContext(Cartstatecontext);
export const useDispatchCart = () => useContext(Cartdispatchcontext);
